// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".3b273af758b9501280863ff5c25e8fb095ccee5f.chunk.js";
};